import { DOT_COLORS, LOAN_REQUEST_TAGS } from 'cpool-constants';
import { SchemaLoanRequestResolver_Get, SchemaLoanRequestResolver_GetSummary } from 'cpool-tables/backend-resolvers';
import type { TFunction } from 'i18next';
import { LuHouse } from 'react-icons/lu';
import { LeadTraitInfo } from '~/types/LeadTraits';

export const getRealEstateInfo = (
    lead: SchemaLoanRequestResolver_GetSummary[number] | SchemaLoanRequestResolver_Get,
    t: TFunction<'de' | 'en', undefined>,
): LeadTraitInfo =>
    lead.filters.includes(LOAN_REQUEST_TAGS.REAL_ESTATE)
        ? {
              dot: DOT_COLORS.GREEN,
              Icon: LuHouse,
              text: t('LEADS.TRAIT.REAL_ESTATE'),
          }
        : null;
